var _circle, _circle2, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup55(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 244,
    height: 203,
    viewBox: "0 0 244 203",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 122.5,
    cy: 101.5,
    r: 90,
    stroke: "#3B5070",
    strokeOpacity: 0.13,
    strokeWidth: 23
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 122.5,
    cy: 101.5,
    r: 63.5,
    stroke: "#7D8A9E",
    strokeOpacity: 0.13,
    strokeWidth: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 76.8272V125.173M32.2642 61.4444V141.654M57.434 38.3704V163.63M83.6981 82.321V117.481M109.962 55.9506V141.654M136.226 12V190M159.208 38.3704V163.63M185.472 76.8272V125.173M211.736 55.9506V147.148M238 76.8272V125.173",
    stroke: "url(#paint0_linear_240_18)",
    strokeWidth: 11,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_240_18",
    x1: 67.7143,
    y1: 54.0887,
    x2: 128.936,
    y2: 177.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7FA2D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BB1BD",
    stopOpacity: 0.97
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup55);
export default __webpack_public_path__ + "static/media/Group 55.7a4310c808173ce8be20a955895d7b95.svg";
export { ForwardRef as ReactComponent };